import React, { Component, useEffect, useState, useContext } from "react";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import Menu from "@mui/material/Menu";
import MenuIcon from "@mui/icons-material/Menu";
import Container from "@mui/material/Container";
import Button from "@mui/material/Button";
import Tooltip from "@mui/material/Tooltip";
import MenuItem from "@mui/material/MenuItem";
import logophoto from "../../assets/logos/HorizontalColor.png";
import LogoutIcon from "@mui/icons-material/Logout";
import "./topbar.css";
import AuthContext from "../../context/AuthContext";
import { useNavigate, Link, NavLink } from "react-router-dom";

// const pages = ["Invoices"];
const ResponsiveAppBar = () => {

  var pagesDict = {
    Home: "/",
    // Invoices: "/invoices",
    Create: "/create",
  };

  let { logoutUser, isAdmin } = useContext(AuthContext);
  const [anchorElNav, setAnchorElNav] = React.useState(null);
  const [anchorElUser, setAnchorElUser] = React.useState(null);


  if (!isAdmin) {
    delete pagesDict.Admin;
    delete pagesDict.Create;
  }
  //get current url and change navigation bar based on it
  let currPath = String(window.location.pathname);
  currPath = currPath.replaceAll("/", "");
  if (currPath === "") {
    delete pagesDict.Home;
  } else {
    delete pagesDict[currPath[0].toUpperCase() + currPath.substring(1)];
  }
  const handleOpenNavMenu = (event) => {
    setAnchorElNav(event.currentTarget);
  };
  const handleLogoutClick = (event) => {
    logoutUser();
  };

  const handleCloseNavMenu = (event) => {
    setAnchorElNav(null);
  };

  const handleCloseUserMenu = () => {
    setAnchorElUser(null);
  };

  return (
    <AppBar sx={{ bgcolor: "white" }} position="sticky">
      <Container>
        <Toolbar disableGutters>
          <Typography
            variant="h6"
            noWrap
            component="div"
            sx={{ mr: 3, display: { xs: "none", md: "flex" } }}
          >
            <img src={logophoto} className="photoLogoWrapper" />
          </Typography>

          <Box sx={{ flexGrow: 1, display: { xs: "flex", md: "none" } }}>
            <IconButton
              size="large"
              aria-label="account of current user"
              aria-controls="menu-appbar"
              aria-haspopup="true"
              onClick={handleOpenNavMenu}
              //   color="inherit"
            >
              <MenuIcon />
            </IconButton>
            <Menu
              id="menu-appbar"
              anchorEl={anchorElNav}
              anchorOrigin={{
                vertical: "bottom",
                horizontal: "left",
              }}
              keepMounted
              transformOrigin={{
                vertical: "top",
                horizontal: "left",
              }}
              open={Boolean(anchorElNav)}
              onClose={handleCloseNavMenu}
              sx={{
                display: { xs: "block", md: "none" },
              }}
            >
              {Object.keys(pagesDict).map((page) => (
                <MenuItem
                  key={page}
                  // component="a" href={pagesDict[page]}
                >
                  <Link to={pagesDict[page]} style={{ textDecoration: "none" }}>
                    <Typography textAlign="center">{page}</Typography>
                  </Link>
                </MenuItem>
              ))}

              {isAdmin && (
                <MenuItem
                  key="Admin"
                  component="a"
                  href="https://docs.djangoproject.com/en/4.1/ref/contrib/admin/"
                  target="_blank"
                >
                  <Typography textAlign="center">Admin</Typography>
                </MenuItem>
              )}
            </Menu>
          </Box>
          <Typography
            variant="h6"
            noWrap
            component="div"
            sx={{ flexGrow: 1, display: { xs: "flex", md: "none" } }}
          >


            
            <img src={logophoto} className="photoLogoWrapper" />
          </Typography>
          <Box sx={{ flexGrow: 1, display: { xs: "none", md: "flex" } }}>
            {isAdmin && (
              <Button
                key="Admin"
                href="https://docs.djangoproject.com/en/4.1/ref/contrib/admin/"
                onClick={handleCloseNavMenu}
                size="large"
                target="_blank"
                sx={{
                  my: 2,
                  color: "rgba(30, 67, 99, 1)",
                  display: "block",
                  textDecoration: "none",
                }}
              >
                Admin
              </Button>
            )}
            {Object.keys(pagesDict).map((page) => (
              <Link key={page} to={pagesDict[page]}>
                <Button
                  onClick={handleCloseNavMenu}
                  size="large"
                  className="buttonStyle"
                  sx={{
                    my: 2,
                    color: "rgba(30, 67, 99, 1)",
                    display: "block",
                  }}
                  style={{ textDecoration: "none" }}
                >
                  {page}
                </Button>
              </Link>
            ))}
          </Box>

          <Box sx={{ flexGrow: 0 }}>
            <Tooltip title="logout">
              <IconButton onClick={handleLogoutClick} sx={{ p: 0 }}>
                <LogoutIcon fontSize="large" />
              </IconButton>
            </Tooltip>
          </Box>
        </Toolbar>
      </Container>
    </AppBar>
  );
};
export default ResponsiveAppBar;
